import './style.scss';
import './userMenu.scss';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from '../login/actions';
import { trackNow } from 'shared/models/analytic';
import { activeOrder } from 'shared/models/user';
import Dropdown from 'components/ui/dropdown';
import UserMenu from './userMenu';
import UserAvatar from 'scy/UserAvatar';
import TrackIcon from 'images/track.gif';
import AsyncAuthModal from 'components/login/asyncModal';
import { SecondaryButton } from 'scy/buttons';

class LoginComponent extends React.Component {
  componentDidUpdate(prevProps) {
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    if (nextUser.objectId && nextUser.objectId !== prevUser.objectId) {
      this.props.loadLoggedInUser();
    }
  }

  openDropDown(type) {
    this.props.showLogin(type);
    trackNow('Nav Login Button');
  }

  render() {
    const { user, loyalty, buttonProps } = this.props;

    return (
      <>
        {!user ? (
          <div className="login-comp">
            <SecondaryButton
              noBorder
              {...buttonProps}
              onClick={() => this.openDropDown('login')}
            >
              Log In
            </SecondaryButton>
            <SecondaryButton
              {...buttonProps}
              onClick={() => this.openDropDown('signup')}
            >
              Sign Up
            </SecondaryButton>
          </div>
        ) : (
          <UserDropdown
            user={user}
            loyalty={loyalty}
            handleLogout={() => this.props.logout()}
            hideTrackIcon={this.props.hideTrackIcon}
          />
        )}
        {(!user || !user.mobileVerified) && <AsyncAuthModal />}
      </>
    );
  }
}

function UserDropdown({ user, loyalty, handleLogout, hideTrackIcon }) {
  const orders = (user && user.orders) || [];
  const currentOrder = activeOrder(user);

  return (
    <Dropdown>
      {({ isOpen, triggerRef, contentRef, forceClose }) => (
        <Fragment>
          <div className="login-comp">
            {!!currentOrder && !hideTrackIcon && (
              <a href="/tracking" className="user-track">
                <img className="user-track-icon" src={TrackIcon} />
              </a>
            )}
            <button className="user-button" ref={triggerRef}>
              <div id="avatar-container">
                <UserAvatar user={user} className="avatar__img" />
              </div>
              <span className="user-name">
                Hi, {user.firstname}
                <i className="icon-down-arrow" />
              </span>
            </button>
          </div>

          {isOpen && (
            <div className="menu-dropdown" ref={contentRef}>
              <UserMenu
                currentPoints={loyalty.currentPoints}
                currentStatus={loyalty.currentStatus}
                nextStatus={loyalty.nextStatus}
                loadingLoyaltyData={loyalty.loading}
                user={user}
                showOrders={!!orders.length}
                logout={handleLogout}
                close={forceClose}
              />
            </div>
          )}
        </Fragment>
      )}
    </Dropdown>
  );
}

function mapStateToProps(state) {
  return {
    ...state.login,
    loyalty: state.loyalty
  };
}

export default connect(
  mapStateToProps,
  { ...actions }
)(LoginComponent);
